import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { actualizarActivo } from "../../utils/activos";

// Edita la fecha de proyección de pago (activos.fecha_planificada) de un CapEx planificado,
// directamente desde el panel "Movimientos Futuros" (hasta ahora solo se podía desde el modal
// Inversión del edificio). Escribe SOLO fecha_planificada — no toca fecha_compra ni el estado,
// así que no dispara depreciación ni saca el activo de la proyección: solo lo reubica en el tiempo.
// Reglas del campo: obligatoria (10.158) y sin fechas pasadas (es proyección a futuro; si el pago
// ya ocurrió, el camino es "Confirmar pago ejecutado").

const HOY = new Date().toISOString().split("T")[0];

const normalizarFecha = (fechaStr) => {
  if (!fechaStr) return "";
  return fechaStr.includes("T") ? fechaStr.substring(0, 10) : fechaStr;
};

const formatMonto = (entry) => {
  const n = Math.abs(Number(entry?.importeEnMoneda || 0));
  const num = n.toLocaleString("es-CL", { maximumFractionDigits: 0 });
  const moneda = entry?.moneda_origen === "USD" ? "US$ " : "";
  return `${moneda}${num}`;
};

const ModificarFechaProyeccionCapexModal = ({ show, onHide, entry, onSaved }) => {
  const [fecha, setFecha] = useState(normalizarFecha(entry?.fecha_display));
  const [guardando, setGuardando] = useState(false);

  if (!entry) return null;

  const handleGuardar = async () => {
    if (!fecha) {
      toast.error("La fecha es obligatoria");
      return;
    }
    if (fecha < HOY) {
      toast.error("La fecha no puede ser anterior a hoy. Si el pago ya ocurrió, usá «Confirmar pago ejecutado».");
      return;
    }
    setGuardando(true);
    try {
      await actualizarActivo(entry.activo_id, { fecha_planificada: fecha });
      toast.success("Fecha de proyección actualizada");
      onSaved?.();
    } catch (e) {
      toast.error(`Error al guardar: ${e.message || e}`);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Modificar fecha de proyección de pago</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: "0.9rem", lineHeight: 1.7, marginBottom: 16 }}>
          <div>
            <strong>Concepto:</strong> {entry.razon_social_receptor || "—"}
          </div>
          <div>
            <strong>Monto:</strong> {formatMonto(entry)}
          </div>
        </div>

        <Form.Group>
          <Form.Label style={{ fontWeight: 600, fontSize: "0.9rem" }}>Fecha de proyección de pago</Form.Label>
          <Form.Control
            type="date"
            value={fecha}
            min={HOY}
            onChange={(e) => setFecha(e.target.value)}
            disabled={guardando}
            style={!fecha ? { borderColor: "#dc3545" } : undefined}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide} disabled={guardando}>
          Cancelar
        </Button>
        <Button variant="primary" size="sm" onClick={handleGuardar} disabled={guardando}>
          {guardando ? "Guardando…" : "Guardar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModificarFechaProyeccionCapexModal;
